var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('user-profile-page-preview',{attrs:{"body":_vm.body}})],1),_c('div',{staticClass:"col-md-3"},[(_vm.id)?_c('UserSidebar',{key:_vm.userKey,attrs:{"id":_vm.id}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }